<template>
  <div class="button-navigation">
    <u-button v-if="currentStep > 0" type="secondary" @click="goToStep(-1)">
      Vorige
    </u-button>
    <u-button :loading="loading" @click="goToStep(1)">
      Volgende
    </u-button>
  </div>
</template>

<script>

  import { createNamespacedHelpers } from 'vuex'
  import UButton from './UButton'

  export default {
    components: {
      UButton
    },
    props: {
      namespace: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        loading: false
      }
    },
    methods: {
      goToStep (direction) {
        this.SET_API_ERRORS({})
        const step = this.currentStep + direction
        const personalDetailsIndex = this.showDurationOptions ? 1 : 0
        if (step < 0) return false
        if (step > personalDetailsIndex) {
          this.SET_SUBMIT_ATTEMPT(true)
          if (this.personalDetailsError) return false
          this.SET_SUBMIT_ATTEMPT(false)
        }
        if (step < this.steps.length) {
          this.GOTO_STEP(step)
        } else {
          this.SET_SUBMIT_ATTEMPT(true)
          if (!this.$error) {
            this.loading = true
            this.submitOrder()
              .then((res) => {
                window.location.replace(res.url)
              })
              .finally(() => {
                this.loading = false
              })
          }
        }
      }
    },
    beforeCreate () {
      const namespace = this.$options.propsData.namespace
      const { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers(namespace)
      // computed 
      this.$options.computed = {
        ...(this.$options.computed || {}),
        ...mapState(['currentStep']),
        ...mapGetters(['steps', 'showDurationOptions', 'personalDetailsError', '$error'])
      }
      // methods
      this.$options.methods = {
        ...(this.$options.methods || {}),
        ...mapMutations(['GOTO_STEP', 'SET_SUBMIT_ATTEMPT', 'SET_API_ERRORS']),
        ...mapActions(['submitOrder'])
      }
    },
  }
</script>

<style lang="scss" scoped>

  @import '../assets/styles/_variables.scss';
  @import '../assets/styles/_mixins.scss';

  .button-navigation {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    text-align: center;
    padding: 1.5em;

    @include screen(md) {
      position: relative;
      padding: 0;
    }

  }

  .u-button {
    width: 100%;

    &:last-of-type {
      margin-top: .75em;
    }
    
    @include screen(md) {
      width: auto;
      margin-top: 0;
      &:last-of-type {
        margin-left: .5em;
      }
    }
    
  }

</style>